import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { MaskCharactersPipe } from './mask-characters.pipe';
import { ContractDetailsPipe } from './contract-details.pipe';
import { ArraysortPipe } from './arraysort.pipe';
import { ArrayGroupPipe } from './array-group.pipe';
import { AggSumPipe } from './agg-sum.pipe';
import { AggTitlePipe } from './agg-title.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { FormatBuPipe } from './formatbu.pipe';
import { GetLifeBenefitsPipe } from './get-life-benefits.pipe';
import { ToolTipFormatPipe } from './tooltip-format.pipe';
import { ToolTipTypePipe } from './tooltip-type.pipe';
import { SetAnchorPipe } from './set-anchor.pipe';
import { AnchorPipe } from './anchor.pipe';
import { CamelCasePipe } from './camel-case.pipe'
import { LifeBenefitsPipe } from './life-benefits.pipe';
import { NotLifeBenefitsPipe } from './life-benefits.pipe';
import { LinkNoHrefPipe } from './link-nohref.pipe';
import { StringSpacetoHyphenPipe } from './string-spaceto-hyphen.pipe';
import { OrderBy } from './orderBy.pipe';
import { SubStringToLowercase } from "./substring-lowercase.pipe";

@NgModule({
  imports: [CommonModule],
  providers: [DatePipe, CurrencyPipe],
  declarations: [
    MaskCharactersPipe,
    ContractDetailsPipe,
    ArraysortPipe,
    ArrayGroupPipe,
    AggSumPipe,
    AggTitlePipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    FormatBuPipe,
    CamelCasePipe,
    GetLifeBenefitsPipe,
    ToolTipFormatPipe,
    ToolTipTypePipe,
    SetAnchorPipe,
    AnchorPipe,
    LifeBenefitsPipe,
    NotLifeBenefitsPipe,
    LinkNoHrefPipe,
    StringSpacetoHyphenPipe,
    OrderBy,
    SubStringToLowercase
  ],
  exports: [
    MaskCharactersPipe,
    ContractDetailsPipe,
    ArraysortPipe,
    ArrayGroupPipe,
    AggSumPipe,
    AggTitlePipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    FormatBuPipe,
    CamelCasePipe,
    GetLifeBenefitsPipe,
    ToolTipFormatPipe,
    ToolTipTypePipe,
    SetAnchorPipe,
    AnchorPipe,
    LifeBenefitsPipe,
    NotLifeBenefitsPipe,
    LinkNoHrefPipe,
    StringSpacetoHyphenPipe,
    OrderBy,
    SubStringToLowercase
  ]
})
export class PipesModule {
  constructor() {}
}
